// API Configuration
export const API_BASE_URL = 'https://crmbackend.italentconnect.in/api';
// export const API_BASE_URL = 'http://localhost:5000/api';

export const SOCKET_URL = 'https://crmbackend.italentconnect.in';


